import { useHookstate } from "@hookstate/core";
import { appStore } from "../../hookstate/appStore";
import { Comic } from "../../types";

const THEME_FACET_GROUP_ID = 2;

export function useComicLabels(comicData?: Comic): string[] {
  const labels = [comicData?.type_display, comicData?.category_name];

  const appInit = useHookstate(appStore.init).get({
    noproxy: true,
  });

  const themeOptions = comicData?.comic_facets
    ?.filter((facet) => facet.comic_facet_group_id === THEME_FACET_GROUP_ID)
    ?.map((facet) => facet.comic_facet_group_option_id) ?? [];

  const themeLabels = appInit.comic_facet_groups
    ?.find((group) => group.id === THEME_FACET_GROUP_ID)
    ?.comic_facet_group_options.filter((option) =>
      themeOptions?.includes(option.id),
    )
    .map((option) => option.display_name);

  labels.push(...(themeLabels ?? []));

  return labels.filter((label): label is string => !!label);
}